import { useMemo } from "react"

import { useAuth } from "@/store/auth"
import { type Permission } from "@/config/permissions"

type Props = {
  permissions: Permission[]
  ifAll?: boolean
}

export function useAuthorized({ permissions, ifAll }: Props) {
  const { user } = useAuth()

  const isAuthorized = useMemo(() => {
    const userPermissions = user?.role?.permissions

    if (!userPermissions) return false

    if (ifAll) {
      return permissions.every(p => userPermissions.includes(p))
    }
    return permissions.some(p => userPermissions.includes(p))
  }, [permissions])

  return isAuthorized
}
